module.exports = __webpack_public_path__ + "img/kafa-3.304a59a6.png";